















import { Component, Vue } from 'vue-property-decorator';
import { State } from 'vuex-class';
import openbitlab from '@/types.d';
import { filter, values, get } from 'lodash';

@Component({
  components: {
  },
})
export default class NetworksView extends Vue {
  @State('projects') projects!: openbitlab.RootState['projects']

  networks: Array<{key: string, name: string}> = [
    { key: 'main', name: 'Mainnet' },
    { key: 'test', name: 'Testnet' },
  ];

  getProjects(network: string): Array<openbitlab.Project> {
    return filter(values(this.projects), (p) => p.status !== 'past' && p.network === network);
  }

  // eslint-disable-next-line class-methods-use-this
  getLogoPath(prj: openbitlab.Project): string {
    const avatar = get(prj, 'logo', 'none.png');
    return `/data/logos/${avatar}`;
  }
}
